import { QuickSelect } from '@/components/types'
import { getTimeBefore } from '../getTimeBefore'
import { subDays } from 'date-fns'

export const quickSelectToTimeBefore = (today: Date, qs: QuickSelect, locale?: Locale) => {
  switch (qs.start) {
    case 'yesterday': {
      const yesterday = subDays(new Date(today.toISOString()), 1)
      return getTimeBefore(yesterday, qs.steps, qs.unit, locale)
    }
    case 'now': {
      const now = new Date(today.toISOString())
      return getTimeBefore(now, qs.steps, qs.unit, locale)
    }
  }
}
